function buildChildRoutesForBrowse({
  pathname,
  onEnterBrowse,
  errorLoading,
  createConditionalComponent,
}) {
  return {
    path: pathname,
    onEnter: onEnterBrowse,
    getComponent(location, cb) {
      System.import(
        /* webpackChunkName: "c_browse" */ `${BASE_PATH}/src/domains/discovery/components/Browse/BrowseAll`,
      )
        .then(module => {
          cb(null, module.default);
        })
        .catch(errorLoading);
    },
  };
}

function buildDiscoveryRoutes({
  routes,
  onBrowseCatalog,
  onEnterPodcastBrowse,
  errorLoading,
  redirectToGenreBackstage,
  AsyncDomain,
  onEnterBrowse,
  createConditionalComponent,
}) {
  const browseChildRoutes = [
    buildChildRoutesForBrowse({
      AsyncDomain,
      pathname: ':type',
      onEnterBrowse,
      errorLoading,
      createConditionalComponent,
    }),
    buildChildRoutesForBrowse({
      AsyncDomain,
      pathname: ':type/:category',
      onEnterBrowse,
      errorLoading,
      createConditionalComponent,
    }),
    buildChildRoutesForBrowse({
      AsyncDomain,
      pathname: ':type/:category/:subcategory',
      onEnterBrowse,
      errorLoading,
      createConditionalComponent,
    }),
    buildChildRoutesForBrowse({
      AsyncDomain,
      pathname: ':type/:category/:subcategory/:subcategory2',
      onEnterBrowse,
      errorLoading,
      createConditionalComponent,
    }),
  ];

  const accumulativeRoutes = routes.concat(
    // Leaving as emptty array and will refactor when WEBCLIENT-10029 is merged
    [],
  );

  accumulativeRoutes.push(
    {
      path: 'browse',
      component: AsyncDomain,
      props: {
        domain: 'discovery',
        component: 'BrowseContainer',
        key: 'BrowseContainer',
      },
      indexRoute: {
        component: AsyncDomain,
        props: {
          domain: 'discovery',
          component: 'Browse',
          key: 'Browse',
        },
      },
      childRoutes: browseChildRoutes,
    },
    {
      path: 'music/:category',
      onEnter: onEnterBrowse,
    },
    {
      path: 'music/:category/:subcategory',
      onEnter: onEnterBrowse,
    },
    {
      path: 'browse/content/:category/:moduleId',
      onEnter: onEnterBrowse,
    },
  );

  accumulativeRoutes.push(
    {
      path: 'browse/catalog/:category',
      onEnter: onBrowseCatalog,
    },
    {
      path: 'browse/catalog/:module/:category',
      onEnter: onBrowseCatalog,
    },
    {
      path: 'browse',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_browse" */ `${BASE_PATH}/src/domains/discovery/components/Browse/BrowseContainer`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'music/:genreCategoryToken/:stationToken',
      onEnter: redirectToGenreBackstage,
    },
    {
      path: 'music/:genreCategoryToken',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_browse" */ `${BASE_PATH}/src/containers/BrowseGenres/BrowseGenreCategory`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
  );

  return accumulativeRoutes;
}

export default {
  buildDiscoveryRoutes,
};
